type VoiceSessionCleanup = () => void | Promise<void>;

let voiceSessionCleanup: VoiceSessionCleanup | null = null;

export const registerVoiceSessionCleanup = (cleanup: VoiceSessionCleanup | null) => {
  voiceSessionCleanup = cleanup;
};

export const runVoiceSessionCleanup = async (): Promise<void> => {
  if (!voiceSessionCleanup) {
    return;
  }

  await voiceSessionCleanup();
};
